import { merge } from 'ramda';

import {
  REQUEST,
  SUCCESS,
  FAIL
} from 'src/store/actions/workTimeSummaryActions';

const initialState = {
  data: {},
  fetching: false,
  errors: []
};

const overUnderTime = (state = initialState, action) => {
  switch (action.type) {
    case REQUEST:
      return merge(state, { fetching: true, data: {} });
    case SUCCESS:
      return merge(state, { data: action.data, fetching: false });
    case FAIL:
      return merge(state, { errors: action.err, fetching: false });
    default:
      return state;
  }
};

export default overUnderTime;
